module.exports = __webpack_public_path__ + "img/bg-analitica.78c3d133.svg";